@if (loaded()) {
  <div class="report-container">
    <hyperkit-typography variant="h5"> Conclusion </hyperkit-typography>
    <hyperkit-select
      label="Outcome"
      [options]="outcomeValues"
      [(ngModel)]="outcome"
      (selectionChange)="onSelectionChange($event)"
      dropdownPosition="absolute"
    ></hyperkit-select>
    <hunt-details-editor
      [title]="huntView.outcomeDependentField()"
      [value]="huntView.outcomeDependent()"
      (valueChange)="huntEditor.updateOutcomeDependent($event)"
    ></hunt-details-editor>
    <hunt-details-editor
      title="Conclusion"
      [value]="huntView.conclusion()"
      (valueChange)="huntEditor.updateConclusion($event)"
    ></hunt-details-editor>
  </div>
} @else {
  <p>Loading…</p>
}
